import React from "react";
import { BrowserRouter, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AdminRouter } from "./router";
import { AuthProvider, SiteProvider, LanguageProvider } from "./contexts";
import { CompanyProvider } from "./contexts/CompanyContext";

export default function App() {
  return (
    <AuthProvider>
      <CompanyProvider>
      <SiteProvider>
      <LanguageProvider>
      <BrowserRouter>
        <AdminRouter />
        <ToastContainer position="top-center" autoClose={2500} hideProgressBar newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" />
      </BrowserRouter>
      </LanguageProvider>
       </SiteProvider>
       </CompanyProvider>
    </AuthProvider>
  );
}